import {RESUME_PREVIEW_PAGES} from "../../data/resumePreview";
import {FiArrowDown, FiArrowUpRight, FiPlus} from "react-icons/fi";
import {CERTIFICATIONS, LANGUAGES, PROFILE, RESUME_PDF_PATH} from "../../data/resume";

export const ResumeSection = () => (
    <section id="resume" className="section shell resume-section" aria-labelledby="resume-title">
        <div className="section-heading">
            <h2 id="resume-title">The full picture.</h2>
            <p>Experience, skills, and background in one place. Take a copy with you.</p>
        </div>
        <div className="resume-actions">
            <a className="action action-primary" href={RESUME_PDF_PATH} download>Download résumé <FiArrowDown aria-hidden="true" /></a>
            <a className="text-link" href={RESUME_PDF_PATH} target="_blank" rel="noopener noreferrer">Open PDF <FiArrowUpRight aria-hidden="true" /></a>
        </div>
        <details className="resume-preview"><summary>Preview résumé <FiPlus aria-hidden="true" /></summary>
            <div className="resume-pages" role="region" aria-label={`${PROFILE.name} résumé preview`} tabIndex={0}>
                {RESUME_PREVIEW_PAGES.map(page => <figure className="resume-page" key={page.page}>
                    <figcaption>Page {page.page} of {RESUME_PREVIEW_PAGES.length} <a href={`${process.env.PUBLIC_URL}/resume-preview/page-${page.page}.webp`} target="_blank" rel="noopener noreferrer" aria-label={`Open résumé page ${page.page} at full size`}>Open full size <FiArrowUpRight aria-hidden="true" /></a></figcaption>
                    <img src={`${process.env.PUBLIC_URL}/resume-preview/page-${page.page}.webp`} width={page.width} height={page.height} alt="" loading="lazy" decoding="async" />
                    <p className="sr-only">{page.text}</p>
                </figure>)}
            </div>
        </details>
        <div className="credentials-grid">
            <div><h3>Certifications</h3><ul>{CERTIFICATIONS.map(cert => <li key={cert.name}>{cert.name}{cert.status && <span className="credential-status">{cert.status}</span>}</li>)}</ul></div>
            <div><h3>Languages</h3><ul>{LANGUAGES.map(language => <li key={language.name} className="language-row"><span>{language.name}</span><span>{language.level}</span></li>)}</ul></div>
        </div>
    </section>
);
